import AppContext from 'App/AppContext';
import { IPStack } from 'baseComponents/Stack/IPStack';
import ProtectedRoute from 'components/Routing/ProtectedRoute';
import SceneBar from 'components/SceneBar/SceneBar';
import { getCurrentPivotKeyFromURL, IScenePivotItemProps } from 'components/SceneBar/ScenePivot';
import { globalNotFoundURL } from 'globalConstants';
import { globalStackItemStylesScroll, globalStackTokensGapMedium } from 'globalStyles';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Switch } from 'react-router-dom';
import TabForms from 'scenes/Admin/ContentConfig/Forms/TabForms';
import TabTags from 'scenes/Admin/ContentConfig/Tags/TabTags';
import { FeatureTypes, hasUserFeature } from 'services/Auth/featurePermissions';
import { TabTemplates } from './Templates/TabTemplates';

interface IAdminContentConfigProps {}

const AdminContentConfig = (props: IAdminContentConfigProps) => {
  const { t } = useTranslation(['translation', 'adminContentConfig']);
  const appContext = useContext(AppContext);

  const _sceneBaseURL = '/admin/content';

  const getPivotItems = (): IScenePivotItemProps[] => {
    const pivotItems: IScenePivotItemProps[] = [
      { key: 'templates', text: t('adminContentConfig:Pivot.Templates'), url: '/templates' },
    ];

    if (hasUserFeature(appContext, FeatureTypes.KPIsAndForms)) {
      pivotItems.push({ key: 'fields', text: t('adminContentConfig:Pivot.Fields'), url: '/forms' });
    }

    pivotItems.push({ key: 'tags', text: t('adminContentConfig:Pivot.Tags'), url: '/tags' });

    return pivotItems;
  };

  const getRedirectUrl = (): string => {
    return `${_sceneBaseURL}/templates`;
  };

  //
  // Main Render
  //
  return (
    <IPStack verticalFill tokens={globalStackTokensGapMedium}>
      <IPStack.Item>
        <SceneBar
          title={t('adminContentConfig:Title')}
          subtitle={t('adminContentConfig:SubTitle')}
          image="admin-content-config.png"
          pivotItems={getPivotItems()}
          selectedPivotKey={getCurrentPivotKeyFromURL(getPivotItems())}
        ></SceneBar>
      </IPStack.Item>
      <IPStack.Item grow styles={globalStackItemStylesScroll}>
        <Switch>
          <ProtectedRoute
            featureType={FeatureTypes.GenericManager}
            path={`${_sceneBaseURL}/templates`}
            render={() => <TabTemplates />}
          />
          <ProtectedRoute
            featureType={FeatureTypes.KPIsAndForms}
            path={`${_sceneBaseURL}/forms`}
            render={() => <TabForms />}
          />
          <ProtectedRoute
            featureType={FeatureTypes.GenericManager}
            path={`${_sceneBaseURL}/tags`}
            render={() => <TabTags />}
          />
          {/* Old bookmarks: without this, the base redirect below prefix-matches and lands on Templates. */}
          <Redirect from={`${_sceneBaseURL}/formfields`} to={`${_sceneBaseURL}/forms`}></Redirect>
          <Redirect from={_sceneBaseURL} to={getRedirectUrl()}></Redirect>
          <Redirect to={globalNotFoundURL}></Redirect>
        </Switch>
      </IPStack.Item>
    </IPStack>
  );
};

export default AdminContentConfig;
